var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var TargetConfig_1;
/* eslint-disable camelcase */
import { JSON, JsonSchemaV2, JsonConverter, MapConverter } from '@symon-ai/wisepipe-serialize';
import './importConfigs/columnUpdate'; // force import for JsonSchemaV2
import { ColumnUpdate } from './importConfigs/columnUpdate';
import { SingerErrorLogConstants } from '@symon-ai/wisepipe-common';
import { targetConfigSchemaValidation } from '../validations.generated';
export const targetConfigSchema = {
    $id: 'urn:wisepipe-common-data:TargetConfig',
    type: 'object',
    properties: {
        delimiter: { type: 'string' },
        s3_bucket: { type: 'string' },
        s3_prefix: { type: 'string' },
        quotechar: { type: 'string' },
        column_limit: { type: 'number' },
        clean_data: { type: 'boolean' },
        columns_to_update: {
            type: 'object',
            additionalProperties: {
                type: 'array',
                items: { $ref: 'urn:wisepipe-common-data:ColumnUpdate' },
                uniqueItems: true
            }
        },
        split_index: { type: 'integer', minimum: 0 },
        buffer_size: { type: 'integer', minimum: 1 },
        generate_sample_files: { type: 'boolean' },
        columns_to_rename: { type: 'array', items: { type: 'array', items: { type: 'string' } } },
        error_file_path: { type: 'string' },
        error_start_marker: { type: 'string' },
        error_end_marker: { type: 'string' },
        is_decimal_org: { type: 'boolean' }
    },
    required: [
        'delimiter',
        's3_bucket',
        's3_prefix',
        'quotechar',
        'column_limit',
        'error_file_path',
        'error_start_marker',
        'error_end_marker'
    ]
};
let TargetConfig = TargetConfig_1 = class TargetConfig {
    constructor(delimiter, s3_bucket, s3_prefix, quotechar, column_limit, local_working_dir, clean_data = true, columnsToUpdate, split_index, buffer_size, generate_sample_files, columnsToRename, isDecimalOrg) {
        this.error_start_marker = SingerErrorLogConstants.TargetErrorStartMarker;
        this.error_end_marker = SingerErrorLogConstants.TargetErrorEndMarker;
        this.delimiter = delimiter;
        this.s3_bucket = s3_bucket;
        this.s3_prefix = s3_prefix;
        this.quotechar = quotechar;
        this.column_limit = column_limit;
        this.clean_data = clean_data;
        this.columns_to_update = columnsToUpdate;
        this.split_index = split_index;
        this.buffer_size = buffer_size;
        this.generate_sample_files = generate_sample_files;
        this.columns_to_rename = columnsToRename;
        this.error_file_path = `${local_working_dir}/${SingerErrorLogConstants.TargetErrorFileName}`;
        this.is_decimal_org = isDecimalOrg ?? false;
        JSON.validate(this, TargetConfig_1);
    }
};
__decorate([
    JsonConverter(new MapConverter(ColumnUpdate))
], TargetConfig.prototype, "columns_to_update", void 0);
TargetConfig = TargetConfig_1 = __decorate([
    JsonSchemaV2(targetConfigSchema, targetConfigSchemaValidation)
], TargetConfig);
export { TargetConfig };
//# sourceMappingURL=targetConfig.js.map